'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _antd = require('antd');

var _Modal = require('../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _utils = require('../../utils');

var _components = require('../../styled/components');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ModalConfirm =
/*#__PURE__*/
function (_react$Component) {
  _inherits(ModalConfirm, _react$Component);

  function ModalConfirm() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ModalConfirm);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ModalConfirm)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.withClose = function (callback) {
      var close = _this.props.close;

      if (callback && (0, _utils.isFunction)(callback)) {
        callback();
      }

      close();
    }, _this.confirm = function () {
      var onOk = _this.props.onOk;
      return _this.withClose(onOk);
    }, _this.cancel = function () {
      var onCancel = _this.props.onCancel;
      return _this.withClose(onCancel);
    }, _temp));
  }

  _createClass(ModalConfirm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? 'Confirm' : _this$props$title,
          _this$props$message = _this$props.message,
          message = _this$props$message === void 0 ? '' : _this$props$message,
          _this$props$buttonOk = _this$props.buttonOk,
          buttonOk = _this$props$buttonOk === void 0 ? 'OK' : _this$props$buttonOk,
          _this$props$buttonCan = _this$props.buttonCancel,
          buttonCancel = _this$props$buttonCan === void 0 ? 'Cancel' : _this$props$buttonCan,
          _this$props$isOpen = _this$props.isOpen,
          isOpen = _this$props$isOpen === void 0 ? true : _this$props$isOpen,
          _this$props$shouldClo = _this$props.shouldCloseOnOverlayClick,
          shouldCloseOnOverlayClick = _this$props$shouldClo === void 0 ? true : _this$props$shouldClo;
      return _react2.default.createElement(_Modal2.default, {
        title: title,
        config: {
          isOpen: isOpen,
          onRequestClose: this.cancel,
          style: {
            content: {
              width: 520
            }
          }
        },
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        footer: _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(_components.ThemedButtonCancel, {
          onClick: this.cancel,
          htmlType: 'button'
        }, buttonCancel), _react2.default.createElement(_components.ThemedButton, {
          onClick: this.confirm,
          htmlType: 'button',
          type: 'primary'
        }, buttonOk))
      }, message);
    }
  }]);

  return ModalConfirm;
}(_react.Component);

exports.default = ModalConfirm;